import { CommApiInstance } from "Utils/CommApiInstance";


const EtcCtxtApi = async (
    ctnt_kind_cd:string,
    ctnt_ctgr_cd:string,
    ganeSvcCd:string
) => {
    return await CommApiInstance.post(`comm/${ganeSvcCd}/${ctnt_kind_cd}/${ctnt_ctgr_cd} `,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default EtcCtxtApi;